<template>
  <div>
    <div class="breadcrumb-section bread-mt">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="page-title">
              <h2 class="text-capitalize">{{ title }}</h2>
            </div>
          </div>
          <div class="col-sm-6">
            <nav aria-label="breadcrumb" class="theme-breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link :to="{ path: '/shop' }"   style="color:#ffd100;">SHOP</router-link>
                </li>
                <li class="breadcrumb-item active" style="color:#ffd100;" v-if="title">{{ title }}</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['title']
}
</script>
